/**
 * Wholesale Analytics API
 * Client for analytics endpoints
 */

import apiClient from '../client';

/**
 * Get customer leaderboard
 */
export const getCustomerLeaderboard = async (params = {}) => {
  const response = await apiClient.get('/wholesale/analytics/customer-leaderboard', { params });
  return response.data;
};

/**
 * Get individual customer stats
 * @param {number} customerId - The customer/distributor ID
 * @param {Object} params - Optional params including start_date, end_date for fiscal period filtering
 */
export const getCustomerStats = async (customerId, params = {}) => {
  const response = await apiClient.get(`/wholesale/analytics/customers/${customerId}/stats`, {
    params
  });
  return response.data;
};

/**
 * Get company loading stats (all companies)
 */
export const getCompanyLoadingStats = async (params = {}) => {
  const response = await apiClient.get('/wholesale/analytics/company-loading-stats', { params });
  return response.data;
};

/**
 * Get individual company stats
 */
export const getCompanyStats = async (companyId, params = {}) => {
  const response = await apiClient.get(`/wholesale/analytics/companies/${companyId}/stats`, {
    params
  });
  return response.data;
};
/**
 * Get overall dashboard stats
 */
export const getDashboardStats = async (params = {}) => {
  const response = await apiClient.get('/wholesale/analytics/dashboard-stats', { params });
  return response.data;
};
